import { render } from "./LeaveCommentsModal.vue?vue&type=template&id=cfa4c0f2&scoped=true"
import script from "./LeaveCommentsModal.vue?vue&type=script&lang=js"
export * from "./LeaveCommentsModal.vue?vue&type=script&lang=js"

import "./leave-comment-modal.scss?vue&type=style&index=0&id=cfa4c0f2&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa4c0f2"]])

export default __exports__